import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class RatingModel {
    count: number = 0;
    description: string = '';
}

@Injectable({
    providedIn: 'root'
})
export class RatingService {

    public ratingObj = new RatingModel();
    public isRating:boolean = false;
    public status: BehaviorSubject<number> = new BehaviorSubject<number>(10);

    constructor(private http: HttpClient) { 
        this.status.subscribe((value) => {  });
    }

    submitRating(status){
        this.status.next(status);
    }
}